import { SuperChartConfiguration_DateRange } from '../../proto/generated/superchart-page'
import { Security } from '../../proto/generated/security'
import { getSecurityKey } from '../../util/security'

const overviewSecurityListByKey = new Map<string, string[]>()

export const getStableOverviewSecurityList = (security: Security): string[] => {
    const key = getSecurityKey(security.exchange, security.code)
    let list = overviewSecurityListByKey.get(key)
    if (!list) {
        list = [key]
        overviewSecurityListByKey.set(key, list)
    }
    return list
}

export const overviewDateRangeKey = (dateRange?: SuperChartConfiguration_DateRange) =>
    dateRange ? `${dateRange.code}|${dateRange.timeBucketCode}|${dateRange.startTime ?? ''}` : ''
